export default "/presentation/resources/sap/ui/webcomponents/main/messagebundle_es.ab14d7ce0bf66489.json"